




import Enumerable from "linq";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { ProgressConditionKinds, ProgressConditionKindsName } from "../../../domain/workflow/kinds";
import { ModelEditableMixin, DisableableMixin } from "../../system/mixins";
import { StandardOption } from "../../system/selectors/mixins";
import OptionDropDownSelector from "../../system/selectors/OptionDropDownSelector.vue";

@Component({
  components: {
    selector: OptionDropDownSelector,
  },
})
export default class ProgressConditionDropDownSelector extends Mixins(ModelEditableMixin, DisableableMixin) {
  @Prop()
  displayProgressConditionKinds: ProgressConditionKinds[];

  get options(): StandardOption<ProgressConditionKinds>[] {
    return Enumerable.from(this.displayProgressConditionKinds)
      .select(p => new StandardOption<ProgressConditionKinds>(ProgressConditionKindsName.getDisplayName(p), p)).toArray();
  }
}
